<template>
  <div
    class="flex flex-col space-y-1.5 px-6 py-4 border-b"
    :class="props.class"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  class?: string
}

const props = defineProps<Props>()
</script>
